/* Review form: opens the pop-up, checks the answers and sends them through Shopify's contact form. */
(function () {
  'use strict';
  var doc = document.documentElement;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }

  /* ---------- open and close the pop-up ---------- */
  function lock(on) { doc.classList.toggle('scroll-lock', !!on); }
  document.addEventListener('click', function (e) {
    var o = e.target.closest ? e.target.closest('[data-rf-open]') : null;
    if (o) {
      var d = $('[data-rf-dlg]');
      if (d && d.showModal) { e.preventDefault(); if (!d.open) d.showModal(); lock(true); var t = $('.rf-head h3', d); if (t) { t.setAttribute('tabindex', '-1'); try { t.focus({ preventScroll: true }); } catch (x) { /* ignore */ } } }
      return;
    }
    var c = e.target.closest ? e.target.closest('[data-rf-close]') : null;
    if (c) { var dd = c.closest('dialog'); if (dd) dd.close(); }
  });
  $$('[data-rf-dlg]').forEach(function (d) {
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    d.addEventListener('close', function () {
      lock(false);
      var sheet = $('.rf-sheet', d); if (sheet) sheet.classList.remove('is-done');
    });
  });

  /* ---------- each form ---------- */
  function setGroup(btns, v, cumulative) {
    btns.forEach(function (b, i) {
      var n = i + 1;
      b.classList.toggle('on', cumulative ? n <= v : n === v);
      b.setAttribute('aria-checked', n === v ? 'true' : 'false');
    });
  }

  function init(form) {
    var mode = form.getAttribute('data-rf') || 'modal';
    var host = form.closest('.rf-sheet') || form.closest('.rf-page') || form.parentNode;
    var thanks = $('[data-rf-thanks]', host);
    var rating = $('[data-rf-rating]', form);
    var text = $('[data-rf-text]', form);
    var count = $('[data-rf-count]', form);
    var pet = $('[data-rf-pet]', form);
    var email = $('[data-rf-email]', form);
    var ok = $('[data-rf-ok]', form);

    // overall stars
    var starBtns = $$('[data-rf-stars] button', form);
    starBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(b.getAttribute('data-v'), 10);
        rating.value = v; setGroup(starBtns, v, true);
        var g = b.closest('.rf-g'); if (g) g.classList.remove('bad');
      });
    });
    // the four optional detail ratings: tap again to clear
    $$('[data-rf-dots]', form).forEach(function (grp) {
      var btns = $$('button', grp);
      var input = grp.parentNode.querySelector('input[type=hidden]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(b.getAttribute('data-v'), 10);
          var same = input.value === String(v);
          input.value = same ? '' : v; input.disabled = same;
          setGroup(btns, same ? 0 : v, false);
        });
      });
    });
    // character counter
    if (text && count) text.addEventListener('input', function () { count.textContent = text.value.length; });
    // product tiles clear their error when chosen
    $$('.rf-tile input', form).forEach(function (r) { r.addEventListener('change', function () { var g = r.closest('.rf-g'); if (g) g.classList.remove('bad'); }); });
    [pet, text, email, ok].forEach(function (el) { if (el) el.addEventListener('input', function () { var g = el.closest('.rf-g'); if (g) g.classList.remove('bad'); }); });
    if (ok) ok.addEventListener('change', function () { var g = ok.closest('.rf-g'); if (g) g.classList.remove('bad'); });

    // links from a review request can carry ?order=1042 and ?product=robocam
    try {
      var q = new URLSearchParams(location.search);
      var order = (q.get('order') || '').replace(/[^\w#-]/g, '').slice(0, 20);
      var oi = $('[data-rf-order]', form);
      if (order && oi) { oi.value = order; oi.disabled = false; }
      var want = (q.get('product') || '').toLowerCase();
      if (want) {
        var pick = $$('.rf-tile input', form).filter(function (r) { var h = r.getAttribute('data-handle') || ''; return want === 'pro' ? /pro$/.test(h) : (want === 'robocam' ? !/pro$/.test(h) : h.indexOf(want) > -1); })[0];
        if (pick) pick.checked = true;
      }
    } catch (err) { /* old browser: fine, the form still works */ }

    function bad(el, on) { var g = el && el.closest('.rf-g'); if (g) g.classList.toggle('bad', !!on); return on; }
    function validate() {
      var first = null;
      function flag(el, on) { if (bad(el, on) && !first) first = el; }
      var tiles = $$('.rf-tile input', form);
      if (tiles.length) flag(tiles[0], !tiles.some(function (r) { return r.checked; }));
      flag(starBtns[0], !rating.value);
      flag(text, text.value.trim().length < 30);
      flag(pet, !pet.value.trim());
      flag(email, email.value.trim() !== '' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value.trim()));
      flag(ok, !ok.checked);
      if (first) { first.scrollIntoView({ block: 'center', behavior: 'smooth' }); try { if (first.focus) first.focus({ preventScroll: true }); } catch (e2) { /* ignore */ } }
      return !first;
    }

    // Shopify sends us back to this page after a successful send: show the thank-you screen
    function showThanks() {
      form.removeAttribute('aria-busy');
      if (mode === 'modal') {
        var d = form.closest('dialog'), sheet = form.closest('.rf-sheet');
        if (sheet) sheet.classList.add('is-done');
        if (d && d.showModal && !d.open) { d.showModal(); lock(true); }
      } else {
        form.classList.add('done'); if (thanks) thanks.classList.add('show');
        if (host && host.scrollIntoView) host.scrollIntoView({ block: 'start' });
      }
      try { history.replaceState(null, '', location.pathname + location.search.replace(/([?&])contact_posted=true&?/, '$1').replace(/[?&]$/, '')); } catch (e3) { /* ignore */ }
    }
    // Shopify sent the form back with an error: reopen the pop-up so the message is seen
    function showError() {
      form.classList.add('has-fail');
      if (mode === 'modal') { var d = form.closest('dialog'); if (d && d.showModal && !d.open) { d.showModal(); lock(true); } }
    }
    window.pmReviewFormRestore = function () { if ($('[data-rf-posted]', form)) showThanks(); else if ($('[data-rf-server]', form)) showError(); };
    window.pmReviewFormRestore();

    // The form is sent the normal Shopify way, so Shopify's own spam check keeps working.
    form.addEventListener('submit', function (e) {
      form.classList.remove('has-fail');
      if (!validate()) { e.preventDefault(); return; }
      // leave out answers that were left empty so the email stays tidy
      $$('select', form).forEach(function (el) { if (!el.value.trim()) el.disabled = true; });
      // Shopify's contact form needs an email address, so if none was given it uses the shop's own support address
      var fb = $('[data-rf-email-fallback]', form);
      if (email && !email.value.trim()) { email.disabled = true; if (fb) fb.disabled = false; }
      form.setAttribute('aria-busy', 'true');
      // close the pop-up so Shopify's spam check (if it ever shows a puzzle) is not hidden behind it
      var dlg = form.closest('dialog');
      if (dlg) { lock(false); dlg.close(); }
      var note = document.createElement('div');
      note.className = 'rf-sending'; note.setAttribute('role', 'status'); note.textContent = 'Sending your review...';
      document.body.appendChild(note);
    });
  }

  $$('form.rf').forEach(init);
})();
